import {
  routeHasHiddenSteps,
  transformEditPathInputDataToProcessRouteStepInput,
} from "@/modules/admin-panel/bpm-routes/shared/ui/path-input/path-input-utils";
import { extractLocalizedValue } from "@/shared/form/localized-value/utils/extract-localized-value";
import { GetDynamicProcessDataToEditQuery } from "gql/graphql";
import { NotificationForm } from "@/modules/admin-panel/notification-templates/shared/notification-form";

export const dynamicProcessDataToProcessRouteStepInput = (
  data?: GetDynamicProcessDataToEditQuery,
) => {
  if (
    data?.getDynamicProcessById.__typename !==
    "DynamicEntityBasedModelDefinitionDto"
  ) {
    return undefined;
  }

  return {
    route: (data?.getDynamicProcessById.route ?? []).map(
      transformEditPathInputDataToProcessRouteStepInput,
    ),
  };
};

/** Есть ли в маршруте процесса шаг с закрытым защитой участником. */
export const dynamicProcessRouteHasHiddenSteps = (
  data?: GetDynamicProcessDataToEditQuery,
): boolean =>
  data?.getDynamicProcessById.__typename ===
    "DynamicEntityBasedModelDefinitionDto" &&
  routeHasHiddenSteps(data.getDynamicProcessById.route ?? []);

export const dynamicProcessDataToDynamicProcessInfoInput = (
  data: GetDynamicProcessDataToEditQuery,
) => {
  if (
    data.getDynamicProcessById.__typename !==
    "DynamicEntityBasedModelDefinitionDto"
  ) {
    return undefined;
  }

  return {
    id: data.getDynamicProcessById.id,
    name: extractLocalizedValue(data.getDynamicProcessById.name),
    metaClass: data.getDynamicProcessById.metaClass,
    fields: data.getDynamicProcessById.fields,
    allowAttachments: data.getDynamicProcessById.allowAttachments,
    autoPatchPersonData: data.getDynamicProcessById.autoPatchPersonData,
    active: data.getDynamicProcessById.active,
    icon: data.getDynamicProcessById.icon?.id,
  };
};

export const dynamicProcessDataToDynamicProcessInitiatorNotificationTemplateValueInput =
  (data?: GetDynamicProcessDataToEditQuery) => {
    if (
      data?.getDynamicProcessById.__typename !==
      "DynamicEntityBasedModelDefinitionDto"
    ) {
      return undefined;
    }

    return NotificationForm.transformers.notificationTemplateValueDtoToNotificationTemplateInput(
      data?.getDynamicProcessById.initiatorNotificationTemplate?.value,
    );
  };

export const dynamicProcessDataToDynamicProcessApproverNotificationTemplateValueInput =
  (data?: GetDynamicProcessDataToEditQuery) => {
    if (
      data?.getDynamicProcessById.__typename !==
      "DynamicEntityBasedModelDefinitionDto"
    ) {
      return undefined;
    }

    return NotificationForm.transformers.notificationTemplateValueDtoToNotificationTemplateInput(
      data.getDynamicProcessById.approverNotificationTemplate?.value,
    );
  };
